import React, { useContext, useState } from "react";
import { Button, Col, Row, Spin } from "antd";
import styles from "../../index.module.scss";
import PhotoItem from "../../../components/PhotoItem";
import AsideBlock from "../../../components/AsideBlock";
import PhotoListModal from "../../../components/PhotoListModal";
import PhotoDetail from "../../../components/PhotoListModal/components/PhotoDetail";
import { InvigilationCtx } from "../../../context";
import { getExamStudentPrintScreenInfo } from "../../../../../../service/exam";
import useExamInfo from "../../../Hook/useExamInfo";

export default function AsidePhotoList() {
    const { currentData } = useContext(InvigilationCtx);

    const [showModal, setShowModal] = useState(false);
    const [current, setCurrent] = useState("");

    const [data, { loading }] = useExamInfo(
        getExamStudentPrintScreenInfo,
        currentData
    );

    return (
        <AsideBlock
            title="抓屏记录"
            count={data?.printScreenList?.length}
            extra={
                <Button
                    type="link"
                    className={styles.button}
                    onClick={() => setShowModal(true)}>
                    查看更多&gt;
                </Button>
            }>
            <Spin spinning={loading}>
                <Row>
                    {data?.printScreenList?.slice(0, 6).map((item, index) => (
                        <Col key={index} span={8}>
                            <PhotoItem
                                time={item.time}
                                url={item.url}
                                onClick={() => setCurrent(item.url)}
                            />
                        </Col>
                    ))}

                    {data?.printScreenList.length === 0 && (
                        <Col span={24}>无抓拍记录</Col>
                    )}
                </Row>
            </Spin>

            <PhotoListModal
                photos={data?.printScreenList || []}
                visible={showModal}
                onCancel={() => setShowModal(false)}
            />

            <PhotoDetail
                visible={!!current}
                photo={current}
                onCancel={() => setCurrent("")}
            />
        </AsideBlock>
    );
}
